module.exports = __webpack_public_path__ + "static/media/hardlock.a248c21f.png";